import React from 'react'
import { Button, Result } from 'antd'

// Hard-coded defaults in case i18n itself is broken or not yet initialized –
// the error fallback must never crash on its own (HOR-11).
const DEFAULT_TEXTS = {
  title: 'Es ist ein Fehler aufgetreten',
  message: 'Die Anwendung ist auf einen unerwarteten Fehler gestoßen. Bitte laden Sie die Seite neu.',
  reload: 'Neu laden',
}

const t = key => {
  try {
    if (typeof global.i18n === 'function') {
      const fullKey = `errors.boundary.${key}`
      const translated = global.i18n(fullKey)
      if (translated && translated !== fullKey) return translated
    }
  } catch (e) {
    // ignore – fall back to default texts below
  }
  return DEFAULT_TEXTS[key]
}

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Result
            status="error"
            title={t('title')}
            subTitle={t('message')}
            extra={
              <Button type="primary" onClick={() => window.location.reload()}>
                {t('reload')}
              </Button>
            }
          />
        </div>
      )
    }
    return this.props.children
  }
}
